import { useMemo } from 'react'

import { useAuth } from '../auth/AuthProvider'
import {
  MessageStatusGuide,
  SmsActivityView,
} from '../conversations/components/SmsActivityView'
import {
  createSmsActivityRepository,
  type SmsActivityRepository,
} from '../conversations/sms-activity-repository'
import { useTenant } from '../tenant/TenantProvider'
import styles from './AutomatedActivityPage.module.css'
import { ReminderPolicyControl } from './ReminderPolicyControl'
import {
  createReminderPolicyRepository,
  type ReminderPolicyRepository,
} from './reminder-policy-repository'

// The messages Flio sent lead, with the one setting staff control and what
// each status means beside them. The DOM order (setting, feed, guide) is the
// order narrow screens show, so keyboard order always matches the layout.
export function AutomatedActivityPage({
  repository,
  policyRepository,
}: {
  repository?: SmsActivityRepository
  policyRepository?: ReminderPolicyRepository
}) {
  const auth = useAuth()
  const tenant = useTenant()
  const currentUser = auth.status === 'authenticated' ? auth.user : null
  const activeRepository = useMemo(
    () =>
      repository ?? createSmsActivityRepository({ getUser: () => currentUser }),
    [repository, currentUser]
  )
  const activePolicyRepository = useMemo(
    () =>
      policyRepository ??
      createReminderPolicyRepository({ getUser: () => currentUser }),
    [policyRepository, currentUser]
  )

  if (!tenant.selectedClinic) return null
  const tenantId = tenant.selectedClinic.id
  return (
    <div className={styles.root}>
      <div className={styles.page}>
        <ReminderPolicyControl
          key={`policy:${tenantId}`}
          className={styles.settings}
          tenantId={tenantId}
          repository={activePolicyRepository}
        />
        <SmsActivityView
          key={`activity:${tenantId}`}
          className={styles.feed}
          tenantId={tenantId}
          repository={activeRepository}
        />
        <MessageStatusGuide className={styles.guide} />
      </div>
    </div>
  )
}
